export default [
    'vegetables',
    'okra',
    'green beans',
    'potatoes',
    'asparagus',
    'kale',
    'cabbage',
    'onion',
    'cauliflower',
    'lettuce',
    'broccoli',
    'brussels sprouts',
    'avocado',
    'beets',
    'carrots',
    'peas',
    'collard greens',
    'eggplants',
    'chard',
    'almonds',
    'macadamia',
    'pecan',
    'cashew',
    'walnut',
    'pistachio',
    'pasta',
    'rice',
    'squash',
    'cranberries',
    'mushrooms',
    'quinoa',
    'apple',
    'pie',
    'tofu',
    'spinach dip',
    'spinach',
    'corn',
    'sweet potatoes',
    'tempeh',
    'beans',
    'pecan pie',
    'zucchini',
    'water',
    'tea',
    'tree bark',
    'whisky',
    'lentils',
    'baked beans',
    'black beans',
    'chickpeas',
    'kidney beans',
    'lima beans',
    'navy beans',
    'pinto beans',
    'brown rice',
    'popcorn',
    'chia seeds',
    'pumpkin seeds',
    'bananas',
    'oranges',
    'strawberries',
    'figs',
    'raisins',
    'almond milk',
    'coconut milk',
    'hummus',
    'zucchini noodles',
    'mango',
    'blueberry',
    'coconut',
    'tomato',
    'artichoke',
    'leek',
    'wine',
    'air',
    'tofurky',
  ];